/* eslint-disable */
export const HTML_CODE = `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
<meta content="width=device-width; initial-scale=1.0; maximum-scale=1.0; user-scalable=0" name="viewport" />
<meta content="yes" name="apple-mobile-web-app-capable" />
<meta content="black" name="apple-mobile-web-app-status-bar-style" />
<meta content="telephone=no" name="format-detection" />
<title>PAGE_NAME</title>
<style>
*html{background-image:url(about:blank);background-attachment:fixed;overflow-x:hidden}
html{background-color:#0e0e0e;height:100%;scrollbar-width:thin;}
body{width:100%;height:100%;margin:0 auto;padding:0;font:12px Arial;overflow-x:hidden;behavior:url(/s/hover.htc);background-attachment:scroll;-webkit-text-size-adjust:none;}  /*   #FFFFBF   */
div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,hr,pre,form,fieldset,input,textarea,blockquote,p{padding:0;margin:0}
hr{margin:0 auto}
table,td,tr,th{font-size:12px}
li{list-style-type:none}
img{border:0;}
ol,ul{list-style:none}
address,cite,code,em,th{font-weight:normal;font-style:normal}
a{text-decoration:none;outline:none;cursor:pointer;outline:none;}
a:hover{text-decoration:underline}
a:visited, a:focus, a:active, a:link {color: inherit; text-decoration:none;}
textarea{font-size:12px;line-height:20px}
.spacer{clear:both;font-size:0;line-height:0;}
.blank {clear:both;height:10px;}
.blank8 {clear:both;height:8px;}
.blank5 {clear:both;height:15px;}
.left {float:left;}
.right {float:right;}

.container {width:100%;min-height:100%;max-width:440px;margin:0 auto;background-color:PAGE_COLOR;background-image:url(PAGE_IMAGE);background-position:center center;background-repeat:no-repeat;background-size:contain;position:relative;}
.con_fixed {position:relative;max-width:440px;margin:0 auto;}
.con_fixed .con_ima_a {display:block;cursor:pointer;width:100%;}
.con_fixed_top, .con_fixed_bottom {position:fixed;left:0;right:0;z-index:10;}
.con_fixed_top {bottom:auto;top:0;}
.con_fixed_bottom {bottom:0;top:auto;}
.c-complete {width:100%;height:100%;display:flex;justify-content:center;align-items:center;}
.c-complete.c-complete-padding {min-height:60px;padding:0 8px;box-sizing:border-box;}
.c-complete.c-complete-padding img {max-width: 880px;zoom:0.5;}
.c-complete.c-complete-end {justify-content:flex-end;}
.c-complete.c-complete__bgimage {position:absolute;top:0;}

.list_ul {width:100%;margin:0 auto;}
.list_ul li {background:#e4e4e4;}
.list_ul li .con_ima_a {display:block;width:100%;overflow:hidden}
.list_ul li .con-link {cursor:pointer;}
.list_ul li .con_ima_a img {width:100%;height:auto;}
</style>
<script>
  var BrowserInfo = {
    userAgent: navigator.userAgent.toLowerCase(),
    isAndroid: Boolean(navigator.userAgent.match(/android/ig)),
    isIphone: Boolean(navigator.userAgent.match(/iphone|ipod/ig)),
    isIpad: Boolean(navigator.userAgent.match(/ipad/ig)),
    isWeixin: Boolean(navigator.userAgent.match(/MicroMessenger/ig)),
  };
  var urlType = {URL_TYPE};
  var iosUrl = {IOS_URL};
  var androidUrl = {ANDROID_URL};

	function getQueryVariable(variable)
	{
	   var query = window.location.search.substring(1);
	   var vars = query.split("&");
	   for (var i=0;i<vars.length;i++) {
			   var pair = vars[i].split("=");
			   if(pair[0] == variable){return pair[1];}
	   }
	   return(false);
	}

	function down() {
		window.location = window.downUrl;
	}

	window.onload=function (){
		var c = getQueryVariable("c");
		var s = getQueryVariable("s");
		var g = getQueryVariable("g");
		var h = getQueryVariable("h");
		var n = getQueryVariable("n");
		var appleid = getQueryVariable("appleid");
		var downUrl ="";
    if(urlType == 2) {
      if (BrowserInfo.isIphone || BrowserInfo.isIpad) {
        window.downUrl = iosUrl;
      } else {
        window.downUrl = androidUrl;
      }
    } else if(appleid){
			window.downUrl = "https://itunes.apple.com/cn/app/"+appleid;
		}else{
			window.downUrl= "https://dl"+h+".caohua.com/APK/"+n+"/"+c+"/"+s+"/"+n+".apk";
		}
	}
</script>
</head>

<body>
  <div class="container">
    {CONTAINER_HTML}
  </div>
</body>
</html>
`
/* eslint-disable */
